import { render, staticRenderFns } from "./SysFillRuleList.vue?vue&type=template&id=12906cca&scoped=true&"
import script from "./SysFillRuleList.vue?vue&type=script&lang=js&"
export * from "./SysFillRuleList.vue?vue&type=script&lang=js&"
import style0 from "./SysFillRuleList.vue?vue&type=style&index=0&id=12906cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12906cca",
  null
  
)

export default component.exports